import { gql } from '../generated'

export const UserFragment = gql(/* GraphQL */ `
  fragment UserFragment on User {
    id
    name
  }
`)
